











































































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "Navigation",
  components: {},
})
export default class Navigation extends Vue {
  public scrollTop = 0;
  public drawer = false;

  public onScroll(e: Event) {
    if (e.target) {
      if (e.target instanceof Document) {
        if (e.target.scrollingElement) {
          this.scrollTop = e.target.scrollingElement?.scrollTop;
        }
      }
    }
  }
}
